import React, { useEffect, useState, useRef } from 'react';
import {
    Typography, Paper, Grid, DialogTitle, DialogContent, DialogActions,
    IconButton,
    InputAdornment,
    Button,
    Dialog
} from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles((theme) => ({
    brV1: {
        borderRadius: 4
    },
    paperWidth: {
        maxWidth: 360,
        width: 360
    },
    dialogContentV1: {
        paddingLeft: 58,
        paddingRight: 58,
        paddingTop: 32,
        paddingBottom: 32
    },
    dialogActionsV1: {
        paddingLeft: 8,
        paddingRight: 8,
        paddingBottom: 8
    },
    closeButton: {
        fontWeight: 'bold',
        backgroundColor: '#E6E6EA',
        borderRadius: 8,
        paddingTop: 17,
        paddingBottom: 17,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#E6E6EA'
        }
    },
    divV2: {
        color: '0b1323',
        marginTop: 16
    },
    divRow: {
        fontSize: 16,
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 6
    },
    dotV1: {
        color: '#e6e6ea',
        fontSize: 10,
        marginLeft: 8,
        marginRight: 8
    },
    tickIcon: {
        fontSize: '11.5em',
        color: '#00875A'
    },
    divContent: {
        textAlign: 'center'
    }
}));

const MultiUserInviteSuccess = ({ open, onClose, userData }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="multi-user-invite-success-dialog" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1, paperWidthXs: classes.paperWidth }}
            >

                <DialogContent className={classes.dialogContentV1} >
                    <div className={classes.divContent} >
                        <div>
                            <CheckCircleIcon className={classes.tickIcon} />
                        </div>
                        <div className={classes.divV2} >
                            You sucessfully invited
                        </div>
                        <div className={classes.divRow} >
                            <div>{userData && userData.name ? userData.name : ""}</div>
                            <FiberManualRecordIcon className={classes.dotV1} />
                            <div>{userData && userData.mobileNumber ? userData.mobileNumber.replace(/(\d{5})(\d{5})/, "$1-$2") : ""}</div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className={classes.dialogActionsV1} >
                    <Button variant="contained" className={classes.closeButton} fullWidth onClick={() => handleClose()} >
                        Close
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}

export default MultiUserInviteSuccess;